$(document).ready(function() {

    $('.favourites-products').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        dots: true,
        fade: false,
        adaptiveHeight: true,
        infinite: true,
        useTransform: true,
        speed: 400,
        cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',   
        centerMode: false,        
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
           }
        }, 
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
            }
        }]
    });   
    $('.recent-project-list, .pj-content-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: false,
        fade: false,
        adaptiveHeight: true,
        infinite: true,
        useTransform: true,
        speed: 400,
        cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',   
        centerMode: false,        
        responsive: [ {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
           }
        }, 
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,   
                centerMode: true,
                centerPadding: '40px',
                dots: true,
            }
        }]
    });
    
    if( $(window).width() < 767 ){  
        $('.wornloved-list').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: false,
            fade: false,
            adaptiveHeight: true,
            infinite: true,
            useTransform: true,
            speed: 400,
            cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',   
            centerMode: false,        
            responsive: [ {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
            }
            }, 
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,   
                    centerMode: true,
                    centerPadding: '10%',
                    dots: false,
                }
            }]
        }); 
        // $('.cart-related-lists').slick({
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: false,
        //     dots: false,
        //     fade: false,
        //     adaptiveHeight: true,
        //     infinite: true,
        //     useTransform: true,
        //     speed: 400,
        //     centerMode: false,        
        //     responsive: [ {
        //         breakpoint: 640,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             centerPadding: '20%',
        //             dots: false,
        //     }
        //     }, 
        //     {
        //         breakpoint: 580,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,   
        //             centerMode: true,
        //             centerPadding: '20%',
        //             dots: false,
        //         }
        //     }]
        // });
    }



    // $('.wt-feature-process-list').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     variableWidth: true,
    //     dots: true,
    //     arrows: true,
    //   });
});